import * as ProductService from "@omni/services/product/product.service";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { Translate } from "@omni/types/utils/translate";
import { Axios } from "axios";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";

import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { IState, TApiAction } from "@/redux/store.types";

import { broadcastAddToCartNotAvailableForServiceProduct } from "../eCommerce.helpers";

export type OnAddToCartHandler = (
    dispatch: ThunkDispatch<IState, Axios, Action<any>>,
    t: Translate
) => (
    sku: string,
    quantity: number,
    deliveryType: string,
    shopCode: string | null | undefined,
    serviceProductSkus: Array<string> | undefined,
    productSubType: string | undefined,
    configuration: unknown | undefined,
    product: Product<ProductFieldSet.Full>
) => Promise<TApiAction<any>>;

const onAddToCartHandler: OnAddToCartHandler =
    (dispatch, t) =>
    (
        sku,
        quantity,
        deliveryType,
        shopCode,
        serviceProductSkus,
        productSubType,
        configuration,
        product
    ) => {
        if (ProductService.isAdditionalService(product)) {
            broadcastAddToCartNotAvailableForServiceProduct(t);
            return Promise.reject<TApiAction>();
        }

        return dispatch(
            CartModule.addECommerceProductToCart(
                {
                    deliveryType: deliveryType,
                    quantity: quantity,
                    shopId: shopCode,
                    sku: sku,
                    additionalServices: serviceProductSkus
                },
                product,
                false,
                productSubType,
                configuration
            )
        );
    };

export { onAddToCartHandler };
